module.exports = __webpack_public_path__ + "static/media/CHZ.d5b961ea.svg";